/* eslint-disable @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-assignment */
import React, { useEffect } from 'react'
import { UnleashClient } from 'unleash-proxy-client'
import {
  FlagProvider,
  useFlags,
  useUnleashContext,
} from '@unleash/proxy-client-react'

const url = process.env.REACT_APP_UNLEASH_URL
const clientKey = process.env.REACT_APP_UNLEASH_CLIENT_KEY

export const unleashEnabled = Boolean(
  url && clientKey && clientKey !== 'CHANGE_ME'
)

const unleashClient = new UnleashClient({
  url: url || 'http://localhost/unleash',
  clientKey: clientKey || 'disabled',
  appName: 'adalo-web-runtime',
  refreshInterval: 180,
})

const ANON_USER_ID = 'web-runtime-anonymous-user'

// `contextFields` is the Unleash context the backend builds (lib/unleashContext.js)
// and embeds on the app body.
const toUnleashContext = contextFields =>
  contextFields?.userId
    ? { userId: contextFields.userId, properties: contextFields.properties ?? {} }
    : { userId: ANON_USER_ID }

export const UnleashContextSync = ({ contextFields }) => {
  const updateContext = useUnleashContext()

  useEffect(() => {
    if (!updateContext) {
      return
    }

    updateContext(toUnleashContext(contextFields)).catch(error => {
      console.error('Failed to update Unleash context', error)
    })
  }, [updateContext, contextFields])

  return null
}

export const FeatureFlagsBoundary = ({ children }) => (
  <FlagProvider unleashClient={unleashClient} startClient={unleashEnabled}>
    {children}
  </FlagProvider>
)

const toFlagsMap = toggles =>
  toggles.reduce((acc, { name, enabled }) => ({ ...acc, [name]: enabled }), {})

// The runner reads flags from a `flags` prop (not hooks) as a Record<string, boolean>;
// pass them all so a new flag needs no change here.
export const withFeatureFlags = Component => {
  const Wrapped = props => {
    const toggles = useFlags()

    return <Component {...props} flags={toFlagsMap(toggles)} />
  }

  Wrapped.displayName = `withFeatureFlags(${Component.displayName ||
    Component.name ||
    'Component'})`

  return Wrapped
}
